import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parsePayoutsSearch } from "@/features/money";
import { PayoutsPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/payouts/")({
  validateSearch: strictSearch(parsePayoutsSearch),
  component: Payouts,
});

function Payouts() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <PayoutsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(payoutId) =>
        router.buildLocation({ to: "/money/payouts/$payoutId", params: { payoutId } }).href
      }
      onOpen={(payoutId) =>
        void router.navigate({ to: "/money/payouts/$payoutId", params: { payoutId } })
      }
    />
  );
}
